<template>
	<div
		 :class="[
			'offer-form-group',
			{'is-disabled': groupheading.isDisabled}
		]"
	>
		<h2 class="common__heading bottom-gap-xs">{{ header }}</h2>
		<h1 class="common__sub-title bottom-gap-xs">{{ subTitle }}</h1>
		<h3 class="common__sub-heading bottom-gap-lg">{{ subHeader }}</h3>
		<div class="offer-form-group__container">
			<div v-if="offer.offtype === 'club'"
				class="offer-form-group__item"
				v-for="(offer, index) in checkboxes"
				:key="index"
			>
				<offer
					:offer="offer"
					@click.native="clickHandler(groupName, index)"
				></offer>
			</div>
		</div>
	</div>
</template>

<script>
	import Offer from '../formFields/Offer.vue';

	export default {
		props: {
			header: {
				type: String
			},
            subTitle: {
                type: String
            },
			subHeader: {
				type: String
			},
            groupheading: {
                type: Object,
                required: true
            },
			checkboxes: {
				type: Array,
				required: true
			},
			groupName: {
				type: String,
				required: true
			},
			clickHandler: {
				type: Function,
				required: true
			}
		},
		components: {
			Offer
		}
	};
</script>

<style lang="scss">
	@import '~sass/_variables.scss';
	@import "~sass/_config.scss";
	@import "~sass/mixins/_media-query.scss";
	@import "~sass/mixins/_attr-bp.scss";

	$columnsFlexBasis: (
		default : 50%,
		mobile: 33.3333%,
		largeMobile: 25%,
		tablet: 16.66666%
	);

	$bottomPadding: (
		default: 30px,
		largeMobile: 50px
	);

	.offer-form-group {
		@include attr-bp($bottomPadding, 'padding-bottom');

		position: relative;

		&__container {
			display: flex;
			justify-content: flex-start;
			flex-direction: column;
			margin-bottom: -15px;
		}

		&__item {
			margin-bottom: 10px;

		}

		&::after {
			content: '';
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			background-color: $col-neutral--0;
			opacity: 0;
			visibility: hidden;
			transition-property: opacity, visibility;
			transition-duration: $ttime;
			transition-delay: 0ms, $ttime;
		}

		&.is-disabled {
			pointer-events: none;

			&::after {
				visibility: visible;
				opacity: 0.6;
				transition-delay: 0ms, 0ms;
			}
		}
	}
</style>

